import {computed} from 'vue'
import {useWindowSize as vueUseWindowSize} from '@vueuse/core'
import screens from 'shared/styles/screens'

export const useWindowSize = () => {
	const {width, height} = vueUseWindowSize()
	const isMobile = computed(() => width.value <= screens.mobile)

	return {
		width,
		height,
		isMobile,
	}
}
